import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, StatusOptions } from "../../../../../../_helpers/Helpers";
import { useEducationTermsUIContext } from "../EducationTermsUIContext";

const prepareFilter = (queryParams, values) => {
  const { 
    term, 
    firstSemesterStart, 
    firstSemesterEnd, 
    secondSemesterStart, 
    secondSemesterEnd,
    thirdSemesterStart,
    thirdSemesterEnd,
    fourthSemesterStart,
    fourthSemesterEnd,
    isActive 
  } = values;
  const newQueryParams = { ...queryParams };
  const filter = { 
    term, 
    firstSemesterStart, 
    firstSemesterEnd, 
    secondSemesterStart, 
    secondSemesterEnd, 
    thirdSemesterStart,
    thirdSemesterEnd,
    fourthSemesterStart,
    fourthSemesterEnd,
    isActive 
  };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function EducationTermsFilter() {
  // EducationTerms UI Context
  const educationTermsUIContext = useEducationTermsUIContext();
  const educationTermsUIProps = useMemo(() => {
    return {
      setQueryParams: educationTermsUIContext.setQueryParams,
      queryParams: educationTermsUIContext.queryParams,
    };
  }, [educationTermsUIContext]);
  
  const { semesterCount } = useSelector(
    (state) => ({
      semesterCount: state.educationTerms.semesterCount
    }),
    shallowEqual
  );

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(educationTermsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, educationTermsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      educationTermsUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        term: "",
        firstSemesterStart: "",
        firstSemesterEnd: "",
        secondSemesterStart: "",
        secondSemesterEnd: "",
        thirdSemesterStart: "",
        thirdSemesterEnd: "",
        fourthSemesterStart: "",
        fourthSemesterEnd: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="term"
                placeholder="Eğitim Dönemi"
                onBlur={handleBlur}
                value={values.term}
                onChange={(e) => {
                  setFieldValue("term", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Eğitim Dönemi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="firstSemesterStart"
                placeholder="Birinci Dönem Başlangıcı"
                onBlur={handleBlur}
                value={values.firstSemesterStart}
                onChange={(e) => {
                  setFieldValue("firstSemesterStart", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Birinci Dönem Başlangıcı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="date"
                className="form-control"
                name="firstSemesterEnd"
                placeholder="Birinci Dönem Sonu"
                onBlur={handleBlur}
                value={values.firstSemesterEnd}
                onChange={(e) => {
                  setFieldValue("firstSemesterEnd", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Birinci Dönem Sonu</b>
              </small>
            </div>

            {
              semesterCount > 1 &&
              <>
                <div className="col-lg-2">
                  <input
                    type="date"
                    className="form-control"
                    name="secondSemesterStart"
                    placeholder="İkinci Dönem Başlangıcı"
                    onBlur={handleBlur}
                    value={values.secondSemesterStart}
                    onChange={(e) => {
                      setFieldValue("secondSemesterStart", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>İkinci Dönem Başlangıcı</b>
                  </small>
                </div>

                <div className="col-lg-2">
                  <input
                    type="date"
                    className="form-control"
                    name="secondSemesterEnd"
                    placeholder="İkinci Dönem Sonu"
                    onBlur={handleBlur}
                    value={values.secondSemesterEnd}
                    onChange={(e) => {
                      setFieldValue("secondSemesterEnd", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>İkinci Dönem Sonu</b>
                  </small>
                </div>
              </>              
            }
            
            {
              semesterCount > 2 &&
              <>
                <div className="col-lg-2">
                  <input
                    type="date"
                    className="form-control"
                    name="thirdSemesterStart"
                    placeholder="Üçüncü Dönem Başlangıcı"
                    onBlur={handleBlur}
                    value={values.thirdSemesterStart}
                    onChange={(e) => {
                      setFieldValue("thirdSemesterStart", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>Üçüncü Dönem Başlangıcı</b>
                  </small>
                </div>

                <div className="col-lg-2">
                  <input
                    type="date"
                    className="form-control"
                    name="thirdSemesterEnd"
                    placeholder="Üçüncü Dönem Sonu"
                    onBlur={handleBlur}
                    value={values.thirdSemesterEnd}
                    onChange={(e) => {
                      setFieldValue("thirdSemesterEnd", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>Üçüncü Dönem Sonu</b>
                  </small>
                </div>
              </>              
            }
            
            {
              semesterCount > 3 &&
              <>
                <div className="col-lg-2">
                  <input
                    type="date"
                    className="form-control"
                    name="fourthSemesterStart"
                    placeholder="Dördüncü Dönem Başlangıcı"
                    onBlur={handleBlur}
                    value={values.fourthSemesterStart}
                    onChange={(e) => {
                      setFieldValue("fourthSemesterStart", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>Dördüncü Dönem Başlangıcı</b>
                  </small>
                </div>

                <div className="col-lg-2">
                  <input
                    type="date"
                    className="form-control"
                    name="fourthSemesterEnd"
                    placeholder="Dördüncü Dönem Sonu"
                    onBlur={handleBlur}
                    value={values.fourthSemesterEnd}
                    onChange={(e) => {
                      setFieldValue("fourthSemesterEnd", e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className="form-text text-muted">
                    <b>Dördüncü Dönem Sonu</b>
                  </small>
                </div>
              </>              
            }

            <div className="col-lg-2">
              <CustomSelect 
                options={StatusOptions}
                value={values.isActive}
                placeholder="Aktif mi?"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("isActive", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Aktif mi?</b>
              </small>
            </div>    
          </div>
        </form>
      )}
    </Formik>
  );
}